module.exports = __webpack_public_path__ + "media/bootstrap-icons/shield-fill-9328bdbf.svg";